import React from "react";
import { useNavigate } from "react-router-dom";
import { ApiConstant } from "../../../../Assets/Constants/ApiConstants";
import { Constent } from "../../../../Assets/Constants/Constent";
import { RightArrowIcon } from "../../../../Assets/Images/CelcomSvgImages";
import { useDispatch } from "react-redux";
import { setTrackStockFieldValue } from "../../../../ReduxFeature/StateFeatures/InventoryDataState";
import { TrackStockItemStatusCal } from "../../../Common/GenericFunctions";

const TrackStockCard = ({
  requestType,
  pageState,
  setPageState,
  data,
  trackRequestDetailsPage,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const isReturnStock = requestType
    ?.toLowerCase()
    ?.includes(ApiConstant.INVENTORY_TRACK_STOCK_RETURN_TYPE.toLowerCase());
  const { className } = TrackStockItemStatusCal(data?.transferStatus);

  return (
    <div className="track-stock-card-section">
     
      <div className="wrapper-track-stock-card-section">
        <div className="normal-card-item-section">
          <div className="card-item-group">
            <div className="card-item-title">
              {Constent.INVENTORY_CARD_TRACK_STOCK_ITEM_TITLE1}
            </div>
            <div className="card-item-value">{data?.transferId || "-"}</div>
          </div>
        </div>
        <div
          className="normal-card-item-section inventory-status-green"
          role="button"
          onClick={() => {
            const dataClone = structuredClone(data);
            dataClone["requestType"] = structuredClone(requestType);
            dispatch(
              setTrackStockFieldValue({
                type: ApiConstant.INVENTORY_TRACK_STOCK_SELECTED_DATA_ITEM,
                value: dataClone,
              })
            ) && navigate("/inventory/trackrequestdetails");
          }}
        >
          <div className="card-item-group">
            <div className="card-item-title">
              {Constent.INVENTORY_CARD_TRACK_STOCK_ITEM_TITLE2}
            </div>
            <div className="card-item-value">{requestType || "-"}</div>
          </div>
          <div className="card-item-group">
            <div className="card-item-title">
              {Constent.INVENTORY_CARD_TRACK_STOCK_ITEM_TITLE3}
            </div>
            <div className="card-item-value">{data?.createDate || "-"}</div>
          </div>
          <div className="card-item-group">
            <div className="card-item-title">
              {Constent.INVENTORY_CARD_TRACK_STOCK_ITEM_TITLE4}
            </div>
            <div className="card-item-value">
              {isReturnStock
                ? data?.transferFromStoreId
                : data?.transferToStoreId || "-"}
            </div>
          </div>
          <div className="card-item-group">
            <div className="card-item-title">
              {Constent.INVENTORY_CARD_TRACK_STOCK_ITEM_TITLE5}
            </div>
            <div className="card-item-value">
              {isReturnStock
                ? data?.transferToStoreId
                : data?.transferFromStoreId || "-"}
            </div>
          </div>
          <div className="card-item-group">
            <div className="card-item-title">
              {Constent.INVENTORY_CARD_TRACK_STOCK_ITEM_TITLE6}
            </div>
            <div className="card-item-value">
              {data?.transferFromStoreName || "-"}
            </div>
          </div>
          <div className="card-item-group">
            <div className="card-item-title">
              {Constent.INVENTORY_CARD_TRACK_STOCK_ITEM_TITLE7}
            </div>
            <div
              className={`card-item-value ${
                data?.transferStatus ===
                ApiConstant.INVENTORY_TRACK_STOCK_AWAITING_RESPONSE
                  ? "status-red"
                  : className
              }`}
            >
              {data?.transferStatus || "-"}
            </div>
          </div>
          <div className="normal-card-item-btn-section">
            <RightArrowIcon stroke={"#009BDF"} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrackStockCard;
